import { get, post, put, del } from "../../data/api";


export async function getEvents() {
    return await get('event')
}
export async function createEvent(params) {

    let event = {
        Title: params.title,
        StartDate: params.startDate,
        EndDate:params.endDate,
        Notes: params.notes,
        RepeatWeekly: params.repeatWeekly,
        RecurrenceEndDate: params.recurrenceEndDate,

    };

    return await post(event, 'event')
}

export async function updateEvent(params, id) {

    let obj = {
        Title: params.title,
        StartDate: params.startDate,
        EndDate: params.endDate,
        Notes: params.notes,
    };

    return await put(obj, 'event/' + id)
}

export async function deleteEvent(id) {
    return await del('event/' + id)
}